import script from "./CreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateModal.vue?vue&type=style&index=0&id=1ff2b47e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff2b47e"]])

export default __exports__